<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="row">
            <div class="col-12">
                <div class="page_action">
                    <div class="tw-w-full text-right">
                        <button
                            type="button"
                            class="btn btn-sm btn-dark"
                            data-toggle="modal"
                            data-target="#addTransport"
                        >
                            <i class="fa fa-file-text-o"> เพิ่มขนส่ง</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover mt-3 mb-0 c_list">
                <thead>
                    <tr class="tw-whitespace-nowrap">
                        <th>ชื่อขนส่ง</th>
                        <th>รายละเอียด</th>
                        <th>ราคาขนส่ง</th>
                        <th>โหมดจัดส่งฟรีเมื่อราคาถึงเงื่อนไข</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="transportSalePageData.length === 0">
                        <td class="text-center" colspan="5">
                            <span
                                class="tw-cursor-pointer"
                                data-toggle="modal"
                                data-target="#addTransport"
                            >
                                ไม่พบบัญชี คลิกเพื่อเพิ่มบัญชี
                            </span>
                        </td>
                    </tr>
                    <tr v-for="(item, index) in transportSalePageData" :key="index">
                        <td>{{ item.transport ? item.transport.name : "" }}</td>
                        <td>{{ item.transport ? item.transport.description : "" }}</td>
                        <td>
                            <input
                                type="number"
                                step="0.01"
                                class="form-control col-md-7"
                                placeholder="ราคาขนส่ง"
                                v-model="item.price"
                            />
                        </td>
                        <td>
                            <toggle-transport-component :transport="item" :shop="shop" :salepage-id="salepageId"/>
                        </td>
                        <td class="text-right tw-w-1">
                            <button
                                @click="confirmDelete(item.id)"
                                type="button"
                                data-type="confirm"
                                class="btn btn-sm btn-danger js-sweetalert"
                                title="Delete"
                            >
                                <i class="fa fa-trash-o"> ลบ</i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal" id="addTransport" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="tw-font-bold">
                            เพิ่มตัวเลือกขนส่ง
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="onClose"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <!-- show transport -->
                        <div class="table-responsive" v-show="showTransportLists">
                            <table class="table table-hover mb-0 c_list tw-whitespace-nowrap">
                                <thead>
                                    <tr>
                                        <th>ชื่อขนส่ง</th>
                                        <th>รายละเอียด</th>
                                        <th class="text-right">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in transportData" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.description }}</td>
                                        <td class="text-right">
                                            <button 
                                                @click="createSalepageTransport(item)"
                                                type="button"
                                                data-type="confirm"
                                                class="btn btn-sm btn-dark"
                                                title="Add">
                                                    <i class="fa fa-plus"></i>
                                                    เพิ่ม
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="transportData.length === 0">
                                        <td class="text-center " colspan="3">
                                            <a @click="showAddNewTransport = !showAddNewTransport, showTransportLists = !showTransportLists">
                                                <span class="tw-cursor-pointer tw-text-blue-500">
                                                    ไม่พบตัวเลือกขนส่งที่ต้องการ
                                                    กดที่นี่เพื่อสร้างข้อมูลขนส่ง
                                                </span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="transportData.length">
                                        <td class="text-center " colspan="3">
                                            <a @click="showAddNewTransport = !showAddNewTransport, showTransportLists = !showTransportLists">
                                                <span class="tw-cursor-pointer tw-text-blue-500">
                                                    คลิกเพื่อสร้างข้อมูลขนส่ง
                                                </span>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- add new transport -->
                        <div class="card" v-show="showAddNewTransport">
                            <div class="tab-content">
                                <div class="tab-pane active">
                                    <form @submit.prevent="handleSubmit()">
                                        <div class="body">
                                            <div class="row clearfix">
                                                <div class="col-md-12 col-lg-12">
                                                    <div class="form-group">
                                                        <label class="tw-ml-2">
                                                            ชื่อขนส่ง
                                                        </label>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="ชื่อขนส่ง"
                                                            v-model="form.name"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <label class="tw-ml-2">
                                                            รายละเอียดขนส่ง
                                                        </label>
                                                        <textarea
                                                            class="form-control"
                                                            v-model="form.description"
                                                            placeholder="รายละเอียด"
                                                            cols="30"
                                                            rows="10"
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="action-btn" class="body">
                                            <div class="tw-w-full text-right">
                                                <button class="btn btn-sm btn-success">
                                                    บันทึก
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-default tw-ml-1"
                                                    @click="showAddNewTransport = false, showTransportLists = true"
                                                >
                                                    ย้อนกลับ
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        shop: {
            required: true,
            type: String
        },
        salepageId: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            loading: false,
            status: {
                addTransport: false,
                conditionFree: true, 
            },
            transportSalePageData: {},
            transportData: [],
            form: {},
            showTransportLists: true,
            showAddNewTransport: false,
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            await axios
                .get(
                    `/backend/s/${this.shop}/transport/manage-salepage/${this.salepageId}`
                )
                .then(res => {
                    this.transportSalePageData = res.data.salepageTransport;
                    this.transportData = res.data.transport;
                });
        },
        handleSubmit() {
            this.store();
        },
        async store() {
            this.loading = true;
            await axios
                .post(`/backend/s/${this.shop}/transport`, this.form)
                .then(res => {
                    this.getData();
                    this.loading = false;

                    this.form = {};
                    this.showTransportLists = true;
                    this.showAddNewTransport = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        "กรุณาใส่ข้อมูลให้ครบถ้วน"
                    );
                });
        },
        async createSalepageTransport(data) {
            this.loading = true;
            await axios
                .post(
                    `/backend/s/${this.shop}/transport/manage-salepage/${this.salepageId}`,
                    data
                )
                .then(res => {
                    this.getData();
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบข้อมูลนี้ใช่ไหม?",
                text: "เมื่อกดยืนยัน ข้อมูลนี้จะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.deleteData(id);
                }
            });
        },
        async deleteData(id) {
            this.loading = true;
            await axios
                .delete(
                    `/backend/s/${this.shop}/transport/manage-salepage/${id}`
                )
                .then(res => {
                    this.getData();
                    this.loading = false;
                })
                .catch(err => {});
        },
        checkActiveArray(arr, id, prop) {
            const index = arr.findIndex(element => {
                return element[prop] === id;
            });
            return index >= 0;
        },
        updateInput(value) {
            this.loading = true;
            axios
                .put(`/backend/s/${this.shop}/transport/manage-salepage/${value.id}/update-price`, value)
                .then(res => {
                  this.getData();
                  this.loading = false;
                })
                .catch(err => {

                });
        },
        onClose() {
            this.showTransportLists = true;
            this.showAddNewTransport = false;

            this.form = {};
        }
    }
};
</script>
<style lang="scss" scoped>
.no-data {
    border: 2px solid #fed736;
    border-radius: 4 px;
    padding: 20px;
    text-align: center;
    margin: 20px;
    font-size: 18px;
    font-weight: bold;
}
</style>
